import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Carlos Borraz</span>
            
            <br />
            Software Engineer | Data Science, Python, Full Stack, Web3 Engineer
            <br />
            <br />
            Open to exciting opportunities where I can make a real impact.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Contributing Public Repos
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Creating technology that drives real impact!"{" "}
          </p>
          <footer className="blockquote-footer">Carlos Borraz</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
